"use client";

import { Box, Button, Flex } from "@chakra-ui/react";
import NextLink from "next/link";

import { ColorModeButton } from "@components/ui/color-mode";
import { InteractiveButton } from "@components/common/InteractiveButton";
import { BrandMarkIcon } from "vectors";

/** Shared top bar for the homepage and standalone marketing pages (e.g. /how-it-works). */
export const SiteTopBar = () => {
  return (
    <Flex
      position="sticky"
      top={0}
      justifyContent="space-between"
      alignItems="center"
      px={{ base: 4, md: 6 }}
      py={2}
      zIndex={20}
      bg="surface.background"
    >
      <NextLink href="/">
        <BrandMarkIcon color="fg" height="25px" w="auto" />
      </NextLink>
      <Flex gap={3} alignItems="center">
        <ColorModeButton _hover={{ backgroundColor: "sidebar.hover" }} />
        <Box display={{ base: "none", sm: "block" }}>
          <NextLink href="/how-it-works">
            <Button size="2xs" variant="surfaceOutline">
              How it works
            </Button>
          </NextLink>
        </Box>
        <NextLink href="/track">
          <Button size="2xs" variant="surfaceOutline">
            Track
          </Button>
        </NextLink>
        <NextLink href="/services">
          <InteractiveButton size="2xs">Get started</InteractiveButton>
        </NextLink>
      </Flex>
    </Flex>
  );
};
